module.exports = __webpack_public_path__ + "assets/img/23_813_big.7ab2e9e3.jpg";